var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseFullscreen = function SvgCloseFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 78.571h21.429V100h14.285V64.286H0V78.57ZM21.429 21.43H0v14.285h35.714V0H21.43v21.429ZM64.286 100H78.57V78.571H100V64.286H64.286V100ZM78.57 21.429V0H64.286v35.714H100V21.43H78.571Z"
  })));
};
export default SvgCloseFullscreen;